import { render, staticRenderFns } from "./AdmitCard.vue?vue&type=template&id=be5c44e8&scoped=true&"
import script from "./AdmitCard.vue?vue&type=script&lang=js&"
export * from "./AdmitCard.vue?vue&type=script&lang=js&"
import style0 from "./AdmitCard.vue?vue&type=style&index=0&id=be5c44e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5c44e8",
  null
  
)

export default component.exports